module.exports = __webpack_public_path__ + "img/sintesis.f6a95b49.svg";